// src/components/DataTable.js
import React, { useEffect, useState } from 'react';
import { Table as DataTable, Button, notification, Modal } from 'antd';
import axios from 'axios';
import '../css/antd.css';
import '../css/reportColoring.css';

import { CSVLink } from 'react-csv';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable'; // Import the autoTable plugin
import * as XLSX from 'xlsx';
import { Link } from 'react-router-dom';
import ModalForm from './ModalForm';
import DeleteModal from './DeleteModal';

import { APP_LOGO, CURRENT_DATE } from '../constants';
import UpdateModal from './UpdateModal';
import { decodeToken } from '../utils/TokenUtils';
import { API_URL, ENDPOINTS } from '../constants/api';
import FeatherIcon from 'feather-icons-react';
import { removeColumns, removeFields } from '../utils/ktcUtils';
import DetailData from './DetailData';
import FormQuery from './FormQuery';

const DTTable = ({
  data,
  reportHeader,
  reportFooter,
  link,
  token,
  executionTime,
}) => {
  const title = link?.page_title;

  const userId = decodeToken(token, 'id');
  const companyBanner = decodeToken(token, 'banner');
  const pageSize = decodeToken(token, 'banner')
    ? 50
    : decodeToken(token, 'banner');
  // console.log('link2:', link);

  const [columns, setColumns] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  const [deleteId, setDeleteId] = useState(null);
  const [updateId, setUpdateId] = useState(null);
  const [updateId2, setUpdateId2] = useState(null);

  const [printedId, setPrintedId] = useState(null);
  const [formQueryId, setFormQueryId] = useState(null);

  const [updateTable, setUpdateTable] = useState(null);

  const [selectedColumns, setSelectedColumns] = useState([]);
  const [columns2, setColumns2] = useState([]);

  const [detailModalVisible, setDetailModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState('');

  // Handle opening the modal
  const openDetailModal = (content) => {
    //console.log('clicked deail');
    setModalContent(content);
    setDetailModalVisible(true);
  };

  const closeDetailModal = () => {
    setDetailModalVisible(false);
  };

  const [statementModalVisible, setStatementModalVisible] = useState(false);
  const [statement, setSatetment] = useState([]);

  // Handle opening the modal
  const openStatementlModal = (id) => {
    //console.log('clicked deail');
    //setModalContent(content);
    fetchStatement(id);
    setStatementModalVisible(true);
  };

  const fetchStatement = async (id) => {
    const statementUrl = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/customer-statement`;
    const values = {
      _id: id,
      from: '0000-00-00',
      to: CURRENT_DATE,
      user_id: userId,
    };
    const response = await axios.post(statementUrl, values, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    console.log(response.data);
    setSatetment(response.data.data);
  };

  const closeStatementModal = () => {
    setStatementModalVisible(false);
  };

  const fieldsToRemove = ['Action', 'Image', 'Print'];

  var insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create/add-print-log`;

  const [modalVisible, setModalVisible] = useState(false); // Manage modal visibility

  const [updateRouteId, setUpdateRouteId] = useState(null);
  const userLevel = decodeToken(token, 'userLevel');
  //console.log('userLevel: ', userLevel, 'Token:', token);

  const [isModalUpdateOpen2, setIsModalUpdateOpen2] = useState(false);

  const openUpdateModal2 = (id, table, routeId) => {
    if (userLevel === 'developer') {
      setUpdateId2(id);
      setUpdateTable(table);
      setUpdateRouteId(routeId);

      // setUpdateTable()
      setIsModalUpdateOpen2(true);
    }
  };
  const closeUpdateModal2 = () => {
    setUpdateId2(null);
    setIsModalUpdateOpen2(false);
  };

  // Function to handle delete button click
  const handleDelete = (id) => {
    setDeleteId(id);
    setModalVisible(true); // Open the modal on delete click
  };

  const handleCancel = () => {
    setModalVisible(false); // Close the modal without deleting
  };

  const [isModalUpdateOpen, setIsModalUpdateOpen] = useState(false);

  const openUpdateModal = (id) => {
    setUpdateId(id);
    // setUpdateTable()
    setIsModalUpdateOpen(true);
  };
  const closeUpdateModal = () => {
    setUpdateId(null);
    setIsModalUpdateOpen(false);
  };

  const [isModalPrintOpen, setIsModalPrintOpen] = useState(false);

  const openPrintModal = (id) => {
    setPrintedId(id);
    // setUpdateTable()
    setIsModalPrintOpen(true);
  };
  const closePrintModal = () => {
    setUpdateId(null);
    setIsModalPrintOpen(false);
  };

  const [isModalFormQueryOpen, setIsModalFormQueryOpen] = useState(false);

  const openFormQueryModal = (id) => {
    setFormQueryId(id);
    // setUpdateTable()
    setIsModalFormQueryOpen(true);
  };
  const closeFormQueryModal = () => {
    setUpdateId(null);
    setIsModalFormQueryOpen(false);
  };

  // Function to dynamically generate columns from the first row of data
  // const generateColumns = (data) => {
  //   if (data && data.length === 0) return []; // If data is empty, return empty columns

  //   // Get the keys from the first row of data (assuming it's an object)
  //   const keys = Object.keys(data[0]);

  //   // Map through the keys to generate column definitions
  //   return keys.map((key) => ({
  //     title: key.charAt(0).toUpperCase() + key.slice(1), // Capitalize column title
  //     dataIndex: key,
  //     key: key,
  //     sorter: (a, b) => {
  //       if (typeof a[key] === 'number' && typeof b[key] === 'number') {
  //         return a[key] - b[key];
  //       } else if (typeof a[key] === 'string' && typeof b[key] === 'string') {
  //         return a[key].localeCompare(b[key]);
  //       } else {
  //         return 0;
  //       }
  //     },
  //     sortDirections: ['ascend', 'descend'],
  //     render: (text) => {
  //       if (typeof text === 'string') {
  //         // Regex to extract href, class, and inner text

  //         const anchorRegex =
  //           /^<a[^>]+href="([^"]+)"[^>]*className="([^"]+)"[^>]*>([^<]+)<\/a>$/;
  //         const match = text.match(anchorRegex);

  //         // ✅ Condition 1: Check if text is a FULL <a> tag
  //         if (match) {
  //           const href = match[1]; // Extract href from <a>
  //           const className = match[2]; // Extract className from <a>
  //           const displayText = match[3]; // Extract inner text of <a>

  //           // ✅ Condition 2: If the link starts with "updatecolumn/", render as a button
  //           if (href.startsWith('updatecolumn/')) {
  //             return (
  //               <button
  //                 className={`btn ${className}`}
  //                 onClick={(e) => updateColumn(e, href)}
  //               >
  //                 {displayText}
  //               </button>
  //             );
  //           }

  //           // ✅ Condition 3: If the link starts with "undo-", render as a button (Undo Delete)
  //           if (href.startsWith('undo-')) {
  //             return (
  //               <button
  //                 className={`btn ${className}`}
  //                 onClick={(e) => undoDelUpdate(e, href)}
  //               >
  //                 {displayText}
  //               </button>
  //             );
  //           }

  //           // ✅ Condition 4: If the link starts with "printedDataId/", render as a button to open a modal
  //           if (href.startsWith('printedDataId/')) {
  //             const printedDataId = href.split('/')[1]; // Extract printedDataId value
  //             return (
  //               <button
  //                 className={`btn ${className}`}
  //                 onClick={(e) => openPrintModal(printedDataId)}
  //               >
  //                 {displayText}
  //               </button>
  //             );
  //           }

  //           // ✅ Condition 5: Otherwise, render it as a regular <a> tag
  //           return (
  //             <a
  //               href={href}
  //               className={`btn ${className}`}
  //               target="_blank"
  //               rel="noopener noreferrer"
  //             >
  //               {displayText}
  //             </a>
  //           );
  //         }

  //         // ✅ Condition 6: If text contains a mix of text and an anchor tag, return as raw text
  //         if (text.includes('<a') && text.includes('</a>')) {
  //           return <span>{text}</span>; // Show full text including anchor tags as raw text
  //         }

  //         // Check for image file extensions
  //         if (
  //           text.endsWith('.jpg') ||
  //           text.endsWith('.png') ||
  //           text.endsWith('.jpeg') ||
  //           text.endsWith('.gif')
  //         ) {
  //           return (
  //             <img
  //               src={`${API_URL}/${text}`}
  //               alt={text}
  //               style={{ width: 50, height: 50, objectFit: 'cover' }}
  //             />
  //           );
  //         }

  //         // Check for document file extensions
  //         if (
  //           text.endsWith('.pdf') ||
  //           text.endsWith('.doc') ||
  //           text.endsWith('.docx')
  //         ) {
  //           return (
  //             <a
  //               href={`${API_URL}/${text}`}
  //               target="_blank"
  //               rel="noopener noreferrer"
  //               style={{ color: '#007bff', textDecoration: 'underline' }}
  //             >
  //               Preview or Download
  //             </a>
  //           );
  //         }
  //       }
  //       return text; // Render plain text for other types
  //     },
  //   }));
  // };

  // Function to dynamically generate columns from the first row of data
  const generateColumns = (data) => {
    if (data && data.length === 0) return []; // If data is empty, return empty columns

    // Get the keys from the first row of data (assuming it's an object)
    const keys = Object.keys(data[0]);

    // Map through the keys to generate column definitions
    // Exclude 'color' column from being displayed
    return keys
      .filter((key) => key !== 'color')
      .map((key) => {
        const parts = key.split('~'); // Split the key by '~'
        const columnTitle = parts[0]; // The first part is the column title
        const hasShowDetail = parts.includes('showDetail'); // Check if 'showDetail' exists
        const color =
          parts.includes('red') ||
          parts.includes('blue') ||
          parts.includes('green')
            ? parts.find((part) => ['red', 'blue', 'green'].includes(part))
            : null; // Check if there's a color

        return {
          title: columnTitle.charAt(0).toUpperCase() + columnTitle.slice(1), // Capitalize column title
          dataIndex: key,
          key: key,
          sorter: (a, b) => {
            if (typeof a[key] === 'number' && typeof b[key] === 'number') {
              return a[key] - b[key];
            } else if (
              typeof a[key] === 'string' &&
              typeof b[key] === 'string'
            ) {
              return a[key].localeCompare(b[key]);
            } else {
              return 0;
            }
          },
          sortDirections: ['ascend', 'descend'],
          render: (text) => {
            if (typeof text === 'string') {
              // Regex to extract href, class, and inner text
              const anchorRegex =
                /^<a[^>]+href="([^"]+)"[^>]*className="([^"]+)"[^>]*>([^<]+)<\/a>$/;
              const match = text.match(anchorRegex);

              if (match) {
                const href = match[1]; // Extract href from <a>
                const className = match[2]; // Extract className from <a>
                const displayText = match[3]; // Extract inner text of <a>

                if (href.startsWith('updatecolumn/')) {
                  return (
                    <button
                      className={`btn ${className}`}
                      onClick={(e) => updateColumn(e, href)}
                      key={key}
                    >
                      {displayText}
                    </button>
                  );
                }
                if (href.startsWith('push--')) {
                  return (
                    <button
                      className={`btn ${className}`}
                      onClick={(e) => pushApi(e, href.replace('push--', ''))}
                      key={key}
                    >
                      {displayText}
                    </button>
                  );
                }
                if (href.startsWith('printedDataId/')) {
                  const printedDataId = href.split('/')[1];
                  return (
                    <button
                      className={`btn ${className}`}
                      onClick={(e) => openPrintModal(printedDataId)}
                      key={key}
                    >
                      {displayText}
                    </button>
                  );
                }
                if (href.startsWith('copyFormQuery/')) {
                  const formId = href.split('/')[1];
                  return (
                    <button
                      className={`btn ${className}`}
                      onClick={(e) => openFormQueryModal(formId)}
                      key={key}
                    >
                      {displayText}
                    </button>
                  );
                }

                return (
                  <a
                    href={href}
                    className={`btn ${className}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    key={key}
                  >
                    {displayText}
                  </a>
                );
              }

              if (text.includes('<a') && text.includes('</a>')) {
                return <span>{text}aa</span>;
              }

              // Handle image or document previews
              if (
                text.endsWith('.jpg') ||
                text.endsWith('.png') ||
                text.endsWith('.jpeg') ||
                text.endsWith('.gif')
              ) {
                return (
                  <img
                    src={`${API_URL}/${text}`}
                    alt={text}
                    style={{ width: 50, height: 50, objectFit: 'cover' }}
                    key={key}
                  />
                );
              }
              if (
                text.endsWith('.pdf') ||
                text.endsWith('.doc') ||
                text.endsWith('.docx')
              ) {
                return (
                  <a
                    href={`${API_URL}/${text}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#007bff', textDecoration: 'underline' }}
                    key={key}
                  >
                    Preview or Download
                  </a>
                );
              }
            }
            return text;
          },
          // Apply conditional row styling if a color is found
          className: color ? `row-color-${color}` : '', // Apply color class if available
        };
      });
  };
  // Handle checkbox toggle
  const handleCheckboxChange = (columnName) => {
    setSelectedColumns((prevSelected) => {
      if (prevSelected.includes(columnName)) {
        // If already selected, remove it
        return prevSelected.filter((col) => col !== columnName);
      } else {
        // If not selected, add it
        return [...prevSelected, columnName];
      }
    });
  };

  useEffect(() => {
    // Dynamically create columns based on data keys
    try {
      const cols = generateColumns(data);
      const editDelColumns = {
        title: 'Action',
        key: 'Action',
        render: (_, record) => (
          <>
            {record.ID && (record.ID !== '' || record.ID !== 0) && (
              <>
                <Button
                  type="danger"
                  onClick={() => openUpdateModal(record.ID)}
                  key={`btn-edit-${record.ID}`}
                >
                  <FeatherIcon
                    icon="edit"
                    size={20}
                    style={{ cursor: 'pointer', color: '#007bff' }}
                    key={`icon-edit-${record.ID}`}
                  />
                </Button>

                <Button
                  type="danger"
                  onClick={() => handleDelete(record.ID)}
                  loading={loading && deleteId === record.ID}
                  key={`btn-del-${record.ID}`}
                >
                  <FeatherIcon
                    icon="trash-2"
                    size={20}
                    style={{ cursor: 'pointer', color: '#dc3545' }}
                    key={`icon-del-${record.ID}`}
                  />
                </Button>
              </>
            )}
          </>
        ),
      };

      const cols2 = cols.some((col) => col.key === 'ID')
        ? [...cols, editDelColumns]
        : cols;
      setColumns(cols2);

      // Extract column names (keys) from the first item of data
      if (data && data.length > 0) {
        const cols = Object.keys(data[0]); // Get all columns from the first data object
        const cols2 = cols.some((col) => col === 'ID')
          ? [...cols, 'Action']
          : cols;
        setColumns2(cols2); // Set column names
        setSelectedColumns(cols2); // By default, all columns are selected
      }
    } catch (error) {
      notification.error({ message: error.message });
    }
  }, [data]);

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  var filteredData;
  try {
    filteredData = data.filter((row) =>
      Object.values(row).some((val) =>
        String(val).toLowerCase().includes(search.toLowerCase())
      )
    );
  } catch (error) {
    notification.error({ message: error.message });
  }

  const getBase64FromUrl = async (imageUrl) => {
    const response = await fetch(imageUrl);
    const blob = await response.blob();

    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  const exportToPDF = async () => {
    // console.log('log response: ', response.data, 'daa:', printLogs)
    const doc = new jsPDF();
    const banner = `${API_URL}/${companyBanner}`;
    // console.log('banner:', banner);
    // Convert image URL to Base64
    const imageBase64 = await getBase64FromUrl(banner);

    // Add the banner image
    const pageWidth = doc.internal.pageSize.getWidth();
    const imgHeight = 40; // Fixed height for the banner image
    const imgY = 10; // Start 10 units from the top

    doc.addImage(imageBase64, 'PNG', 0, imgY, pageWidth, imgHeight);

    // Add title below the banner image
    const titleY = imgY + imgHeight + 10;
    doc.setFontSize(16);
    const textWidth = doc.getTextWidth(title);
    const titleX = (pageWidth - textWidth) / 2;
    doc.text(title, titleX, titleY);

    // Add JSON key-value header data in a grid layout
    doc.setFontSize(12);
    let yOffset = titleY + 10; // Start position for the header
    if (reportHeader && reportHeader.length > 0) {
      const headerKeys = Object.entries(reportHeader[0]);

      for (let i = 0; i < headerKeys.length; i += 2) {
        const firstPair = headerKeys[i];
        const secondPair = headerKeys[i + 1];

        doc.text(`${firstPair[0]}: ${firstPair[1]}`, 14, yOffset);

        if (secondPair) {
          doc.text(`${secondPair[0]}: ${secondPair[1]}`, 110, yOffset);
        }

        yOffset += 7;
      }
    }

    // Compute unselected columns
    const unCheckedFields = columns2.filter(
      (col) => !selectedColumns.includes(col)
    );

    // Combine default fields with unchecked columns
    const combinedFieldsToRemove = [...fieldsToRemove, ...unCheckedFields];

    const printFilteredData = removeColumns(
      filteredData,
      combinedFieldsToRemove
    );

    const keys = Object.keys(printFilteredData[0]);

    const tableColumn = keys.map((col) => col);

    // console.log('Data: ', filteredData)
    const tableRows = filteredData.map((row) => {
      const record0 = columns.map((col) => row[col.key]);
      // const record = columns.map(col => escapeSingleQuotes(String(row[col.key])));

      //console.log('row:', row, 'record:', record0, 'record0:', record0); // Log the row to check if the data is correct
      return record0;
    });

    // Generate PDF with autoTable plugin
    doc.autoTable({
      startY: yOffset + 10, // Start table below the header

      head: [tableColumn],
      body: tableRows,
    });

    doc.save(title + '.pdf');

    const printLogs = {
      user_id: userId,
      link_id: link.id,
      print_data: JSON.stringify(printFilteredData),
      header_data: '',
      footer_data: '',
      ip_address: '',
      user_agent: '',
      print_action: 'pdf',
    };
    const response = await axios.post(insertUrl, printLogs, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
  };

  const exportToExcel = async () => {
    // Compute unselected columns
    const unCheckedFields = columns2.filter(
      (col) => !selectedColumns.includes(col)
    );

    // Combine default fields with unchecked columns
    const combinedFieldsToRemove = [...fieldsToRemove, ...unCheckedFields];

    const printFilteredData = removeColumns(
      filteredData,
      combinedFieldsToRemove
    );

    const printLogs = {
      user_id: userId,
      link_id: link.id,
      print_data: JSON.stringify(printFilteredData),
      header_data: '',
      footer_data: '',
      ip_address: '',
      user_agent: '',
      print_action: 'excel',
    };
    const response = await axios.post(insertUrl, printLogs, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    const ws = XLSX.utils.json_to_sheet(printFilteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'data');
    XLSX.writeFile(wb, title + '.xlsx');
  };

  const exportToCsv = async (e) => {
    const printLogs = {
      user_id: userId,
      link_id: link.id,
      print_data: JSON.stringify(filteredData),
      header_data: '',
      footer_data: '',
      ip_address: '',
      user_agent: '',
      print_action: 'csv',
    };
    const response = await axios.post(insertUrl, printLogs, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
  };

  const updateColumn = async (e, href) => {
    e.preventDefault();
    const updateUrl = `${API_URL}/${ENDPOINTS.SYS}/${href}`;
    try {
      const response = await axios.put(
        updateUrl,
        {},
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        }
      );

      //console.log(`response: `,response.data)
      notification.success({ message: response.data.message });
    } catch (error) {
      //console.log(`url: ${updateUrl}, error ${error.message}`)
      notification.error({ message: error.message });
    }
  };

  const undoDelUpdate = async (e, href) => {
    e.preventDefault();
    const updateUrl = `${API_URL}/${ENDPOINTS.SYS}/${href}`;
    try {
      const response = await axios.get(
        updateUrl,

        {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        }
      );

      //console.log(`response: `,response.data)
      notification.success({ message: response.data.message });
    } catch (error) {
      //console.log(`url: ${updateUrl}, error ${error.message}`)
      notification.error({ message: error.message });
    }
  };

  const pushApi = async (e, href) => {
    e.preventDefault();
    const updateUrl = `${API_URL}/${ENDPOINTS.SYS}/${href}`;
    console.log(updateUrl);
    try {
      const response = await axios.get(
        updateUrl,

        {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        }
      );

      //console.log(`response: `,response.data)

      notification.success({ message: response.data.message });
    } catch (error) {
      //console.log(`url: ${updateUrl}, error ${error.message}`)
      notification.error({ message: error.message });
    }
  };

  const openInNewTab = async (e) => {
    e.preventDefault(); // Prevent default behavior of the Link

    // const noPrint = ['Action', 'Image', 'Print'];
    // const printFilteredData = removeFields(filteredData, noPrint)

    // Compute unselected columns
    const unCheckedFields = columns2.filter(
      (col) => !selectedColumns.includes(col)
    );

    // Combine default fields with unchecked columns
    const combinedFieldsToRemove = [...fieldsToRemove, ...unCheckedFields];

    const printFilteredData = removeColumns(
      filteredData,
      combinedFieldsToRemove
    );

    const jsonData = {
      title: title,
      logo: APP_LOGO,
      tableData: printFilteredData,
      reportHeader: reportHeader,
      reportFooter: reportFooter,
    };

    const printLogs = {
      user_id: userId,
      link_id: link.id,
      print_data: JSON.stringify(printFilteredData),
      header_data: '',
      footer_data: '',
      ip_address: '',
      user_agent: '',
      print_action: 'print',
    };
    const response = await axios.post(insertUrl, printLogs, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });

    localStorage.setItem('printData', JSON.stringify(jsonData)); // Store data in localStorage
    window.open('/print', '_blank'); // Open the link in a new tab
  };

  // console.log('link:', link);

  // Function to get row class name based on row's color column value
  const getRowClassName = (record) => {
    if (record.color) {
      return `row-color-${record.color.toLowerCase()}`; // Convert to lowercase to match class
    }
    return 'row-color-default'; // Default class if no color
  };

  return (
    <div className="" style={{ padding: '20px' }}>
      <br />
      <div className="row">
        {/* {link?.reg_route && 
        <div className='col-6'>
            <button className="btn btn-primary" onClick={openModal}>
            {link?.reg_name}
          </button>
         
          <ModalForm userId={userId}  token={token} route={link?.reg_route} isOpen={isModalOpen} onRequestClose={closeModal} />
         
        </div>
         } */}
        <div className="col-3">
          <h2
            onDoubleClick={() => openUpdateModal2(link?.id, 'ktc_link', 7)}
            title={
              userLevel === 'developer'
                ? `Double click to update/edit the ${link?.page_title} form`
                : '' + userLevel
            }
          >
            {title}
          </h2>
        </div>
      </div>

      {deleteId && (
        <DeleteModal
          userId={userId}
          token={token}
          table={link?.table_name}
          id={deleteId}
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
        />
      )}
      {updateId2 && (
        <UpdateModal
          userId={userId}
          token={token}
          table={updateTable}
          update_link_id={updateRouteId}
          id={updateId2}
          isOpen={isModalUpdateOpen2}
          onRequestClose={closeUpdateModal2}
        />
      )}
      {updateId && (
        <UpdateModal
          userId={userId}
          token={token}
          table={link?.table_name}
          update_link_id={link?.update_link_id}
          id={updateId}
          isOpen={isModalUpdateOpen}
          onRequestClose={closeUpdateModal}
        />
      )}
      {printedId && (
        <DetailData
          userId={userId}
          token={token}
          route="get-printed-data"
          title={title}
          id={printedId}
          isOpen={isModalPrintOpen}
          onRequestClose={closePrintModal}
        />
      )}

      {formQueryId && (
        <FormQuery
          userId={userId}
          token={token}
          route=""
          title={title}
          id={formQueryId}
          isOpen={isModalFormQueryOpen}
          onRequestClose={closeFormQueryModal}
        />
      )}

      {/* Flexbox container for the buttons and search */}

      <div className="d-flex justify-content-between align-items-center mb-3">
        {/* Export Buttons - Left aligned */}
        {/* filteredData && filteredData.length > 0 && */}
        <div>
          <button onClick={exportToPDF} className="btn btn-primary mr-2">
            Export PDF
          </button>
          {/* <a onClick={exportToCsv} className="" href="/">
            <CSVLink
              data={filteredData}
              filename={title + '.csv'}
              className="btn btn-success mr-2"
            >
              Export CSV
            </CSVLink>
          </a> */}
          <button onClick={exportToExcel} className="btn btn-warning mr-2">
            Export Excel
          </button>

          <Link
            to="/print"
            className="btn btn-info"
            onClick={openInNewTab} // Add the click handler
          >
            Print
          </Link>
        </div>
        {/* User Profile Dropdown */}
        <ul className="navbar-nav ms-auto">
          <li className="nav-item dropdown">
            <a
              className=" nav-link dropdown-toggle"
              href="/"
              id="userDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Show/Hide
            </a>
            <ul className="dropdown-menu " aria-labelledby="userDropdown">
              {columns2.map((column) => (
                <li key={column} className="dropdown-item">
                  &nbsp;
                  <label>
                    <input
                      type="checkbox"
                      checked={selectedColumns.includes(column)} // Check if this column is selected
                      onChange={() => handleCheckboxChange(column)} // Toggle checkbox
                      key={`input-${column}`}
                    />
                    &nbsp;{column}
                  </label>
                </li>
              ))}
            </ul>
          </li>
        </ul>

        {/* Search Input - Right aligned */}
        <input
          type="text"
          placeholder="Search..."
          value={search}
          onChange={handleSearch}
          className="form-control mb-3"
          style={{ maxWidth: '300px' }} // Optional: Limit max width for better alignment
        />
      </div>
      <div className="container mt-4">
        {reportHeader && reportHeader.length > 0 && (
          <center>
            <h2>{title}</h2>
          </center>
        )}
        {reportHeader &&
          reportHeader.map((item, index) => (
            <div key={index} className="row mb-3">
              {Object.entries(item).map(([key, value], i) => (
                <div className="col-md-6 mb-2" key={i}>
                  <strong>{key}:</strong> {value}
                </div>
              ))}
            </div>
          ))}
      </div>
      {/* DataTable */}
      {data && data.length > 0 && (
        <DataTable
          //columns={columns}
          columns={columns.filter((col) => selectedColumns.includes(col.key))}
          dataSource={filteredData}
          rowKey="name"
          // scroll={{ x: 'max-content' }} // Adjusts table layout to prevent horizontal scrolling
          // rowClassName={(record) =>
          //   record.color ? `row-color-${record.color}` : ''
          // }

          rowClassName={getRowClassName} // Apply row color based on 'color' column
          onRow={(record) => ({
            onDoubleClick: (e) => {
              // Check if the column has 'showDetail' and open the modal
              const keys = Object.keys(record);

              keys.forEach((key) => {
                if (key.includes('showDetail')) {
                  //   console.log(`Details for ${record[key]}`);

                  openDetailModal(`Details for ${record[key]}`);
                } else if (key.includes('statement')) {
                  //   console.log(`Details for ${record[key]}`);

                  openStatementlModal(record[key]);
                }
              });
            },
          })}
          scroll={{ x: false }}
          // scroll={{ x: false, y: 400 }} // Disable horizontal scrolling
          // virtual={true} // This enables virtual scrolling (only visible rows are rendered)

          locale={{
            emptyText:
              filteredData.length === 0
                ? 'No Data Available'
                : 'No matching data',
          }}
          pagination={{
            defaultPageSize: pageSize, // Set the default number of records per page to 100
            showSizeChanger: true, // Optionally, allow the user to change the page size
            pageSizeOptions: ['10', '20', '50', '100', '250', '500', '1000'], // Provide options for page size
          }}
        />
      )}
      {executionTime !== null && (
        <p>
          Request executed in: {executionTime.toFixed(2)} sec - Total rows:
          {data && data.length} rows
        </p>
      )}

      {/* Modal for showing details */}
      <Modal
        title="Details"
        open={detailModalVisible} // Use 'open' instead of 'visible'
        onCancel={closeDetailModal}
        footer={[
          <Button key="close" onClick={closeDetailModal}>
            Close
          </Button>,
        ]}
      >
        <p>{modalContent}</p>
      </Modal>

      {/* Modal for showing statement */}
      <Modal
        title="Statement"
        open={statementModalVisible} // Use 'open' instead of 'visible'
        onCancel={closeStatementModal}
        footer={[
          <Button key="close" onClick={closeStatementModal}>
            Close
          </Button>,
        ]}
        width={1000} // Adjust the width to make it larger (default is 520px)
        style={{
          maxWidth: '90%', // Optionally limit the modal width to 90% of the screen
          height: '80%', // Set a custom height for the modal
        }}
        bodyStyle={{
          padding: '20px', // Add padding to the body content
        }}
      >
        {statement.length > 0 && (
          <div className="table-responsive">
            <table className="table table-border">
              <thead>
                <tr>
                  {/* Create table headers dynamically based on the keys of the first object */}
                  {statement.length > 0 &&
                    Object.keys(statement[0]).map((key) => (
                      <th key={key}>{key}</th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {/* Loop through the data array to create rows */}
                {statement.map((row, index) => (
                  <tr key={index}>
                    {Object.values(row).map((value, i) => (
                      <td key={i}>{value}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default DTTable;
